module.exports = __webpack_public_path__ + "static/media/icon_file_pdf.e41688df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_pdf.svg
// module id = 157
// module chunks = 0